const defaultWidth = 16;
const defaultHeight = 16;

export const ConditionIcon = ({ width = defaultWidth, height = defaultHeight, color = '#24292E' }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8424 8.57613C11.0767 8.34181 11.4566 8.34181 11.6909 8.57613L13.6909 10.5761C13.9252 10.8104 13.9252 11.1903 13.6909 11.4247L11.6909 13.4247C11.4566 13.659 11.0767 13.659 10.8424 13.4247C10.6081 13.1903 10.6081 12.8104 10.8424 12.5761L11.8181 11.6004L2.6 11.6004C2.26863 11.6004 2 11.3318 2 11.0004C2 10.669 2.26863 10.4004 2.6 10.4004L11.8181 10.4004L10.8424 9.42465C10.6081 9.19034 10.6081 8.81044 10.8424 8.57613Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.1576 2.57613C4.92328 2.34181 4.54338 2.34181 4.30907 2.57613L2.30907 4.57613C2.07476 4.81044 2.07476 5.19034 2.30907 5.42465L4.30907 7.42465C4.54338 7.65897 4.92328 7.65897 5.1576 7.42465C5.39191 7.19034 5.39191 6.81044 5.1576 6.57613L4.18186 5.60039L13.4 5.60039C13.7314 5.60039 14 5.33176 14 5.00039C14 4.66902 13.7314 4.40039 13.4 4.40039L8.79093 4.40039L4.18186 4.40039L5.1576 3.42465C5.39191 3.19034 5.39191 2.81044 5.1576 2.57613Z"
        fill={color}
      />
    </svg>
  );
};

ConditionIcon.displayName = 'ConditionIcon';
